module.exports = __webpack_public_path__ + "static/img/ent-detail-6.75c9ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-6.jpg
// module id = +N+L
// module chunks = 51